//Ares Roles
export const ARES_TRAINER = 'trainer';
export const ARES_PLAYER = 'player';
export const ARES_NONE = 'none';

//Cyberbridge Roles
export const CMT_ADMIN = 'cmt_admin';
export const CUSTOMER_ADMIN = 'customer_admin';
export const PLAYER = 'player';
